import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const VaSessionActions = createActionGroup({
  source: 'VaSession',
  events: {
    'Check Session Expiry': props<{ expiryDate: Date }>(),
    'Expire Session': emptyProps(),
    'Set Session Valid': emptyProps(),
  },
});
